<template>
	<div style="height: calc(100vh - 56px); overflow-y: scroll;">
		<div class="mx-auto mt-4" style="max-width: 1320px;">
			<div>
				<CCol>
					<clientFilter v-if="isSysAdmin || isGroupAdmin" class="" />
				</CCol>
			</div>
			<div class="d-flex">
				<CCol>
					<div class="border bg-white d-flex flex-column">
						<div class="p-2 px-4 text-center font-weight-bolder m-auto">
							AP Spend
						</div>
						<div
							class="border-top p-2 text-center font-weight-bolder d-flex justify-content-center position-relative">
							{{ apSpend }}
						</div>
					</div>
				</CCol>
				<CCol>
					<div class="border bg-white d-flex flex-column">
						<div class="p-2 px-4 text-center font-weight-bolder m-auto">
							Total Opportunity
						</div>
						<div
							class="border-top p-2 text-center font-weight-bolder d-flex justify-content-center position-relative">
							{{ totalOpportunity }}
						</div>
					</div>
				</CCol>
			</div>

			<div class="d-flex">
				<CCol>
					<div class="border bg-white d-flex flex-column">
						<div class="p-2 text-center font-weight-bolder m-auto">Spend Mapped for Opportunity Development
						</div>
						<div
							class="border-top p-4 text-center font-weight-bolder d-flex justify-content-center position-relative">
							<GaugeChart style="height: 300px; width: 90%;" :chart-data="spendMappedChartData"
								:isHalf="true" :key="1" :legendFontSize="14" />
							<div class="position-absolute" style="bottom: 32px;">
								<div>{{ spendMappedChartData.label }}%</div>
								<div>{{ spendMappedChartData.dollarVal }}</div>
							</div>
						</div>
					</div>
				</CCol>
				<CCol>
					<div class="border bg-white d-flex flex-column">
						<div class="p-2 text-center font-weight-bolder m-auto">Opportunity Status</div>
						<div class="border-top p-4 py-3">
							<HorizontalBarChart style="height: 300px" :chart-data="spendOpportunityChartByStatusData"
								:key="1">
							</HorizontalBarChart>
						</div>
					</div>
				</CCol>
			</div>
			<div class="d-flex">
				<CCol sm="12">
					<CCard class="mb-0">
						<CCardBody>
							<div class="pagination-container">
								<CButtonGroup class="align-items-center">
									<CButton color="white" size="sm" :disabled="isPrevPageDisabled"
										:class="{ selected: isPrevPageDisabled }" @click="moveToPage('FIRST')"
										class="nextButton">
										First
									</CButton>
									<CButton color="white" size="sm" :disabled="isPrevPageDisabled"
										:class="{ selected: isPrevPageDisabled }" @click="moveToPage('PREV')"
										class="nextButton">
										Previous</CButton>
									<small class="h6 m-0 mx-3">
										{{ `${offset + 1} - ${offset + limit > totalOppGroupCount ?
											totalOppGroupCount : offset + limit} of ${totalOppGroupCount}` }}
									</small><br />
									<CButton color="white" size="sm" :disabled="isNextPageDisabled"
										:class="{ selected: isNextPageDisabled }" @click="moveToPage('NEXT')"
										class="nextButton">
										Next
									</CButton>
									<CButton color="white" size="sm" :disabled="isNextPageDisabled"
										:class="{ selected: isNextPageDisabled }" @click="moveToPage('LAST')"
										class="nextButton">
										Last
									</CButton>
								</CButtonGroup>
							</div>
							<div class="grid-container-with-2-columns">
								<div>
									<BarChart2 style="height: 416px" :chart-data="spendOpportunityChartData" :key="1">
									</BarChart2>
								</div>
								<div>
									<CDataTable class="sticky-header-table" stickyHeader striped
										:items="spendOpportunityTableData" :fields="SPEND_OPPORTUNITY_TABLE_COLUMNS"
										:column-filter="false" :items-per-page="limit">
									</CDataTable>
								</div>
							</div>
						</CCardBody>

					</CCard>
				</CCol>
			</div>
		</div>
	</div>
</template>

<script>
import _ from "../Utility/utility";
import gql from "graphql-tag";
import clientFilter from "../../components/clientFilter";
import { storeData } from "../../store";
import { mapMutations } from 'vuex';
import BarChart2 from "../../components/charts/BarChart2";
import HorizontalBarChart from "../../components/charts/HorizontalBarChart";
import GaugeChart from "../../components/charts/GaugeChart";
import { getSelectedClients } from "../../store";

export default {
	data() {
		return {
			apSpend: "",
			totalOpportunity: "",
			AP_PO_SPEND_TABLE_COLUMNS: [{ key: "vendor_source" }, { key: "po" }, { key: "non_po" }, { key: "ap" }],
			CONTRACT_SPEND_TABLE_COLUMNS: [{ key: "vendor_name" }, { key: "ap_spend" }, { key: "po_spend" }],
			spinner: false,
			spendData: {},
			spendMappedChartData: {},
			apSpendOnPOChartData: {
			},
			contractSpendChartData: {
			},
			poExcessApSpendChartData: {
			},
			mappedOpportunityDevelopmentChartData: {
			},
			SPEND_OPPORTUNITY_TABLE_COLUMNS: [
				{
					key: "group",
					_style: "min-width: 130px",
				},
				{ key: "opportunity", label: "Opportunity" },
				{ key: "spend", label: "Spend" },
			],
			spendOpportunityChartData: {},
			SPEND_OPPORTUNITY_BAR_CHART_DATASET_CONFIGS: [
				{
					key: "percent_savings",
					label: "Percent Opportunity",
					barColor: '#94c973'
				},
			],
			spendOpportunityTableData: [],
			spendOpportunityChartByStatusData: {},
			SPEND_OPPORTUNITY_BY_STATUS_BAR_CHART_DATASET_CONFIGS: [
				{
					key: "potential_savings",
					label: "Potential Savings",
					barColor: '#94c973'
				},
			],

			isNextPageDisabled: false,
			isPrevPageDisabled: true,
			offset: 0,
			limit: 10,
			totalOppGroupCount: 0,
		};
	},
	components: {
		clientFilter,
		GaugeChart,
		BarChart2,
		HorizontalBarChart,
	},
	computed: {
		isSysAdmin() {
			return storeData.currentUserDetails.role.name === "sys_admin";
		},
		isGroupAdmin() {
			return storeData.currentUserDetails.role.name === "group_admin";
		},
		selectedClients() {
			return getSelectedClients();
		}
	},
	watch: {
		async selectedClients() {
			this.spinner = true;
			await this.fetchData();
			this.spinner = false;
		},
		async offset() {
			await this.fetchOpportunityGroupsAggregateData();
		},
	},
	methods: {
		...mapMutations(['setStatusFilter']),

		getBarChartData(rawData, chartConfigs) {
			return {
				datasets: chartConfigs.map(config => ({
					data: rawData[config.key],
					backgroundColor: config.barColor,
					label: config.label,
				})),
				labels: rawData.xAxisLabels,
				tooltipLabels: rawData.xAxisLabels,
			};
		},
		async fetchOpportunityGroupsAggregateData() {
			await this.$apollo
				.mutate({
					mutation: SPENDMD_DB_OPPORTUNITY_DASHBOARD_QUERIES_OPP_GROUPS_AGGREGATE_DATA,
					variables: {
						clients: this.selectedClients,
						offset: this.offset,
					},
				})
				.then((res) => {
					let result = res.data.spendmd_db_opportunity_groups_v2_aggregate;
					if (result) {
						const tempChartData = {
						};

						const tempSpendOpportunityTableData = [];

						this.SPEND_OPPORTUNITY_BAR_CHART_DATASET_CONFIGS.forEach(config => {
							tempChartData[config.key] = [];
						});
						tempChartData.xAxisLabels = [];

						result.nodes.forEach((el) => {
							this.SPEND_OPPORTUNITY_BAR_CHART_DATASET_CONFIGS.forEach(config => {
								tempChartData[config.key].push(el[config.key]);
							})
							tempChartData.xAxisLabels.push(el.opportunity_group);

							tempSpendOpportunityTableData.push({
								group: el.opportunity_group,
								opportunity: el.potential_savings,
								spend: el.total_spend,
							})
						});

						this.spendOpportunityChartData = this.getBarChartData(tempChartData, this.SPEND_OPPORTUNITY_BAR_CHART_DATASET_CONFIGS);
						this.spendOpportunityTableData = tempSpendOpportunityTableData;
					}
				}).catch((err) => {
					console.log(err);
				});
		},
		async fetchData() {
			this.offset = 0;
			await this.$apollo
				.mutate({
					mutation: SPENDMD_DB_OPPORTUNITY_DASHBOARD_QUERIES,
					variables: {
						clients: this.selectedClients,
					},
				})
				.then((res) => {
					this.apSpend = res.data.spendmd_db_total_spend_and_opportunity_aggregate.aggregate.sum.total_spend;
					this.totalOpportunity = res.data.spendmd_db_total_spend_and_opportunity_aggregate.aggregate.max.potential_savings;

					this.totalOppGroupCount = res.data.paginatedCount.aggregate.count;
					let result = res.data.spendmd_db_opportunity_groups_v2_aggregate;

					if (result) {
						this.isNextPageDisabled = this.offset + this.limit >= this.totalOppGroupCount;

						const tempChartData = {
						};

						const tempSpendOpportunityTableData = [];

						this.SPEND_OPPORTUNITY_BAR_CHART_DATASET_CONFIGS.forEach(config => {
							tempChartData[config.key] = [];
						});
						tempChartData.xAxisLabels = [];

						result.nodes.forEach((el) => {
							this.SPEND_OPPORTUNITY_BAR_CHART_DATASET_CONFIGS.forEach(config => {
								tempChartData[config.key].push(el[config.key]);
							})
							tempChartData.xAxisLabels.push(el.opportunity_group);

							tempSpendOpportunityTableData.push({
								group: el.opportunity_group,
								opportunity: el.potential_savings,
								spend: el.total_spend,
							})
						});

						this.spendOpportunityChartData = this.getBarChartData(tempChartData, this.SPEND_OPPORTUNITY_BAR_CHART_DATASET_CONFIGS);
						this.spendOpportunityTableData = tempSpendOpportunityTableData;
					}
					result = res.data.spendmd_db_summary_dashboard_gauges[0];
					this.spendMappedChartData = {
						labels: [
							''
						],
						datasets: [
							{
								backgroundColor: [this.$themeColors.green["300"], this.$themeColors.green["200"]],
								data: [
									result.percent_opp_developed * 100, (1 - result.percent_opp_developed) * 100
								]
							}
						],
						label: (result.percent_opp_developed * 100).toFixed(0),
						dollarVal: result.dollar_opp_developed,
					};



					result = res.data.spendmd_db_opportunity_by_status_aggregate;

					const tempChartDataByStatus = {
					};

					this.SPEND_OPPORTUNITY_BY_STATUS_BAR_CHART_DATASET_CONFIGS.forEach(config => {
						tempChartDataByStatus[config.key] = [];
					});
					tempChartDataByStatus.xAxisLabels = [];

					result.nodes.forEach((el) => {
						this.SPEND_OPPORTUNITY_BY_STATUS_BAR_CHART_DATASET_CONFIGS.forEach(config => {
							tempChartDataByStatus[config.key].push(_.parseAmountToInt(el[config.key]));
						})
						tempChartDataByStatus.xAxisLabels.push(el.opportunity_set_status);
					});
					this.spendOpportunityChartByStatusData = this.getBarChartData(tempChartDataByStatus, this.SPEND_OPPORTUNITY_BY_STATUS_BAR_CHART_DATASET_CONFIGS);

				}).catch((err) => {
					console.log(err);
				});
		},

		async moveToPage(target) {
			switch (target) {
				case "FIRST":
					this.offset = 0;
					this.isPrevPageDisabled = true;
					this.isNextPageDisabled = false;
					break;
				case "NEXT":
					this.offset = this.offset + this.limit;
					this.isPrevPageDisabled = false;
					if (this.offset + this.limit >= this.totalOppGroupCount) {
						this.isNextPageDisabled = true;
					}
					break;
				case "PREV":
					this.offset = this.offset - this.limit;
					this.isNextPageDisabled = false;
					if (this.offset - this.limit < 0) {
						this.isPrevPageDisabled = true;
					}
					break;
				case "LAST":
					const residue = this.totalOppGroupCount % this.limit;
					this.offset = this.totalOppGroupCount - residue;
					this.isNextPageDisabled = true;
					this.isPrevPageDisabled = false;
					break;
				default:
					break;
			}
		},
	},
	async mounted() {
		this.spinner = true;
		await this.fetchData();
		this.spinner = false;
	}
};

const SPENDMD_DB_OPPORTUNITY_DASHBOARD_QUERIES = gql`
	query (
			$clients: json
            $offset: Int
		) {
		spendmd_db_opportunity_groups_v2_aggregate(
			args: {
				clients: $clients
			}
			limit: 10
			offset: $offset
			order_by: {percent_savings: desc_nulls_last, total_spend: desc_nulls_last}
			) {
			nodes {
				opportunity_group
				potential_savings
				total_spend
				percent_savings
			}
			aggregate {
				count
			}
		}
		paginatedCount: spendmd_db_opportunity_groups_v2_aggregate(
			args: {
				clients: $clients
			}
		) {
			aggregate {
				count
			}
		}  
		spendmd_db_total_spend_and_opportunity_aggregate(
			args: {
				clients: $clients
			}
			) {
			aggregate {
				sum {
					total_spend
				}
				min {
					ap_start
					po_start
				}
				max {
					ap_end
					po_end
					potential_savings
				}
			}
			nodes {
				client_id
			}
		}
		spendmd_db_opportunity_by_status_aggregate(
			args: {
				clients: $clients
			}
			) {
			nodes {
				opportunity_set_status
				potential_savings
			}
			aggregate {
				count
			}
		}
		spendmd_db_summary_dashboard_gauges(
			args: {
				clients: $clients
			}
		) {
			id
			percent_opp_developed
			dollar_opp_developed
		}
	}
`;

const SPENDMD_DB_OPPORTUNITY_DASHBOARD_QUERIES_OPP_GROUPS_AGGREGATE_DATA = gql`
	query (
			$clients: json
            $offset: Int
		) {
		spendmd_db_opportunity_groups_v2_aggregate(
			args: {
				clients: $clients
			}
			limit: 10
			offset: $offset
			order_by: {percent_savings: desc_nulls_last, total_spend: desc_nulls_last}
			) {
			nodes {
				opportunity_group
				potential_savings
				total_spend
				percent_savings
			}
			aggregate {
				count
			}
		}
	}
`;
</script>

<style scoped>
.grid-container-with-2-columns {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 64px;
	align-items: end;
}

.sticky-header-table::v-deep>div {
	height: 420px;
	overflow-y: auto;
	position: inherit;
}

.sticky-header-table::v-deep table {
	margin-bottom: 0;
}

.sticky-header-table::v-deep .pagination {
	margin-bottom: 0;
	margin-top: 16px;
}

.sticky-header-table::v-deep table>thead {
	position: sticky;
	top: 0;
	z-index: 1;
}

.sticky-header-table::v-deep table>thead>tr>th {
	padding: 0;
	border: none;
	border-bottom: 2px solid;
	border-bottom-color: #d8dbe0;
}

.sticky-header-table::v-deep table>thead>tr>th>div {
	padding: 12px;
	background-color: white;
}

.sticky-header-table::v-deep table>thead>tr>th>div.column-filter {
	padding: 8px 0;
	border-bottom: none;
}

.pagination-container {
	display: flex;
	justify-content: center;
	margin: 0px 0 16px;
}

.nextButton {
	padding: 8px 16px;
	margin: auto 2px;
	background-color: white !important;
	color: #1f2621 !important;
}

.nextButton[disabled=disabled] {
	cursor: not-allowed;
}

.selected {
	background-color: #9ca8a9 !important;
	color: #ffffff !important;
}
</style>
